// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as PpTableColSchema from "./PpTableColSchema.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as GenericListView$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/GenericListView.bs.js";

var ListRecord = {};

var ListView = GenericListView$Catalyst.Make(ListRecord);

function fetchData(msisdn, offset, successCb, errorCb, country) {
  var RepoInstance = CrmRepoManager.getPremiumPartnerReportRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchSubscriptionReport, msisdn, offset, country);
              }), (function (param) {
                return Curry._1(successCb, {
                            recs: param.subscription_logs,
                            offset: param.next_offset_ts
                          });
              }), Curry.__1(errorCb));
}

function PpSubscriptionList(Props) {
  var msisdn = Props.msisdn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return React.createElement(ListView.make, {
              columns: PpTableColSchema.getListSchema(undefined),
              fetchData: (function (param) {
                  var func = function (param$1, param$2, param$3) {
                    return fetchData(msisdn, param, param$1, param$2, param$3);
                  };
                  return function (param) {
                    var func$1 = Curry._1(func, param);
                    return function (param) {
                      return Curry._2(func$1, param, country);
                    };
                  };
                })
            });
}

var make = PpSubscriptionList;

export {
  ListRecord ,
  ListView ,
  fetchData ,
  make ,
  
}
/* ListView Not a pure module */
